import { findValue } from './FindValue'

export const reorderFields = (selectedFieldsS1, selectedFieldsS2) => {
        // creates arrays to hold matched and unmatched fields for each scenario
        const unmatchedScenario1 = [];
        const unmatchedScenario2 = [];
        const matchedScenario1 = [];
        const matchedScenario2 = [];

        for (let field of selectedFieldsS1) {
            // tries to find each of the selected fields from scenario 1 in the list of selected fields from scenario 2
            let s2Field = selectedFieldsS2.find(f => f.name === field.name);
            
            if (s2Field === undefined) {
                // if the field in not found push the sceanario 1 field into the scenario 1 unmatched fields and set the field's status to new
                field.status = 'new';
                unmatchedScenario1.push(field);

            } else if (findValue(s2Field).value === findValue(field).value) {
                // if the field exists in both scenarios and their values match then set the status of each field to ''(no class) and push to both scenario's matching arrays
                field.status = '';
                s2Field.status = '';
                matchedScenario1.push(field);
                matchedScenario2.push(s2Field);

            } else {
                // if the field exists in both scenarios and their values are different set the status of the fields to 'different' and push to both scenario's matching arrays
                field.status = 'different';
                s2Field.status = 'different';
                matchedScenario1.push(field);
                matchedScenario2.push(s2Field);
            }
        }

        for (let field of selectedFieldsS2) {
            // check if each field has been found by matching a field from scenario 1
            let alreadyFound = matchedScenario2.find(f => f.name === field.name);

            if (alreadyFound === undefined) {
                // if a field is not found then it only belongs to scenario 2 so set its status to 'new' and push it to scenario 2's unmatched array
                field.status = 'new';
                unmatchedScenario2.push(field);
            }
        }

        let fieldsS1 = matchedScenario1.concat(unmatchedScenario1);
        let fieldsS2 = matchedScenario2.concat(unmatchedScenario2);
        return { fieldsS1, fieldsS2 };
}